import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { recordActions } from '../configuration/react';

const useAutobizTrade = (recordId, tradeId, autobizTradeDate) => {
  const dispatch = useDispatch();
  const trade = useSelector((state) => state.reduxRecords.data[recordId]?.trade || {});
  const [isLoadingTrade, setIsLoadingTrade] = useState(false);
  const [errorTrade, setErrorTrade] = useState(null);

  const getSale = async () => {
    setErrorTrade(null);
    setIsLoadingTrade(true);
    try {
      dispatch(recordActions.getSale());
    } catch (e) {
      setErrorTrade(e.message);
    } finally {
      setIsLoadingTrade(false);
    }
  };

  useEffect(() => {
    if (recordId > 0 && tradeId !== null && autobizTradeDate !== null && autobizTradeDate !== undefined) {
      getSale();
    }
  }, [recordId, tradeId]);

  return { trade, isLoadingTrade, errorTrade };
};

export default useAutobizTrade;
